// src/pages/hr/HRAdministration.jsx
import React from "react";
import HRComingSoon from "./HRComingSoon";

export default function HRAdministration() {
  return (
    <HRComingSoon
      icon="⚙️"
      title="HR Administration"
      description="Configure roles & permissions, approval matrix, workflow configurations, email templates, system settings, and data import/export tools. Coming soon."
    />
  );
}
